import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M21.6 8.84759V17.4C21.6 18.1956 21.284 18.9587 20.7213 19.5213C20.1587 20.0839 19.3957 20.4 18.6 20.4H5.40002C4.60438 20.4 3.84131 20.0839 3.2787 19.5213C2.71609 18.9587 2.40002 18.1956 2.40002 17.4V8.84759L11.6952 14.3172C11.7876 14.3716 11.8928 14.4004 12 14.4004C12.1072 14.4004 12.2125 14.3716 12.3048 14.3172L21.6 8.84759ZM18.6 4.79999C19.3382 4.79987 20.0505 5.07192 20.6007 5.56408C21.1508 6.05624 21.5002 6.73396 21.582 7.46759L12 13.104L2.41802 7.46759C2.49981 6.73396 2.84921 6.05624 3.39938 5.56408C3.94954 5.07192 4.66185 4.79987 5.40002 4.79999H18.6Z',
                    fill: '#A7ABC3',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const PbMailFilled = React.forwardRef(IconComponent);
PbMailFilled.displayName = 'PbMailFilled';

export { PbMailFilled };
